import { render } from "./DetailedBlog1.vue?vue&type=template&id=3d077c83&scoped=true"
import script from "./DetailedBlog1.vue?vue&type=script&lang=js"
export * from "./DetailedBlog1.vue?vue&type=script&lang=js"

import "./DetailedBlog1.vue?vue&type=style&index=0&id=3d077c83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d077c83"]])

export default __exports__